import React from 'react';
import { DateRangePicker } from '../../../../Constant';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import DateRangedata from './DateRangedata';
import SingleDate from './SingleDate';
import TimeAndDate from './TimeAndDate';
import HeaderCard from '../../../Common/HeaderCard';

const FormDateRangepickerContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle={DateRangePicker} parent='Form Widgets' title={DateRangePicker} />
      <Row>
        <Col>
          <Card>
            <HeaderCard title={DateRangePicker} />
            <CardBody>
              <Row className='date-range-picker'>
                <DateRangedata />
                <SingleDate />
                <TimeAndDate />
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default FormDateRangepickerContain;
